import { render, staticRenderFns } from "./getAsset.vue?vue&type=template&id=a0f243dc&"
import script from "./getAsset.vue?vue&type=script&lang=js&"
export * from "./getAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports